module.exports = __webpack_public_path__ + "images/saaremaa/routes/pointers/RIN-ROO-RIN.png";